<mat-card>
  <mat-card-header class="hide-on-print">
    <main-header class="header"></main-header>
  </mat-card-header>

  <mat-card-content>
    <main>
      <router-outlet></router-outlet>
    </main>    
  </mat-card-content>

  <mat-card-actions class="hide-on-print">
  </mat-card-actions>

  <mat-card-footer class="hide-on-print">
    <main-footer></main-footer>
  </mat-card-footer>
</mat-card>

